<template>
<div>
    <!-- <base-alert variant="danger" v-model="showAlert">
        {{ text }}
    </base-alert> -->
    <loading-anim :active="!$route.query.ko && $route.query.redirect" fullScreen></loading-anim>
    <div v-if="$route.query.ko" class="flexCenter">
        <div>
            <div class="mb-4">
                <h2>{{$t('payments.errorTitle')}}</h2>
            </div>
            <div>
                <span v-html="$t('payments.errorTxt')"></span>
            </div>
            <div style="margin-top:20px;text-align:center;">
                <b-button v-on:click="retry">{{$t('payments.retry')}}</b-button>
            </div>
        </div>
    </div>
    <div v-if="$route.query.expired" class="flexCenter">
        <div>
            <div class="mb-4">
                <h2>{{$t('payments.expiredTitle')}}</h2>
            </div>
            <div>
                <span v-html="$t('payments.expiredTxt')"></span>
            </div>
        </div>
    </div>
    <base-dialog v-model="showDialog" 
        :content="dialogText" :okFn="hideDialog"></base-dialog>
    <form id="paytpvPaymentForm" style="display: flex;justify-content: center;" v-if="!$route.query.redirect && !$route.query.expired">
        <div>
            <div><base-input class="bold" :label="$t('payments.holdername')" v-model="holdername" :dataAttributes="{ 'data-paytpv': 'cardHolderName' }" ></base-input></div>
            <div><base-input class="bold" :label="$t('payments.cardnumber')" v-model="cardnumber" :dataAttributes="{ 'data-paytpv': 'paNumber' }"></base-input></div>
            <div><span class="bold">{{$t('payments.expiration')}}</span></div>
            <div><span>{{$t('month')}}:</span></div>
            <div>
                    <base-select v-model="month" :options="months" :placeholder="$t('selectMonth')" label="text"></base-select>
                    <select v-model="month" data-paytpv="dateMonth" v-show="false">
                        <option v-for="month in months" v-bind:value="month.value" v-bind:key="month">{{month.text}}</option>
                    </select>
            </div>
            <div><span>{{$t('year')}}:</span></div>
            <div>
                <base-select v-model="year" :options="years" :placeholder="$t('selectYear')" label="text"></base-select>
                <select v-model="year" data-paytpv="dateYear" v-show="false">
                    <option v-for="year in years" v-bind:value="year.value" v-bind:key="year">{{year.text}}</option>
                </select>
            </div>
            <div>
                <div><base-input class="bold" :label="$t('payments.cvv')" v-model="cvv" :dataAttributes="{ 'data-paytpv': 'cvc2' }"></base-input></div>
                <div style="display: flex;align-items: center;">
                    <img src="https://api.paycomet.com/gateway/img/cvv2.png" alt="CVC2" width="34" height="21" title="CVC2" style="margin-right:5px; float:left;" />
                    <span>{{$t('payments.3digits')}}</span>
                </div>
            </div>

            <div style="margin-top:20px;text-align:center;">
                <img src="https://api.paycomet.com/gateway/assets/img/clockpayblue.gif" alt="Espere" width="41" height="30" id="clockwait" style="display:none; margin-top:5px;" />
                <b-button type="submit" v-on:click="pay">{{$t('payments.accept')}}</b-button>
            </div>
        </div>
    </form>
</div>
</template>

<script>
import BaseInput from '@/components/base/forms/BaseInput'
import BaseSelect from '@/components/base/forms/BaseSelect'
import { BButton } from 'bootstrap-vue'
import LoadingAnimVue from '@/components/utils/LoadingAnim.vue'
import BaseDialog from '@/components/base/BaseDialog'
import BaseAlert from '@/components/base/ui/BaseAlert'
import { inProductionEnv, getBaseDomain } from '@/helpers/global.helpers'

export default {
    components: {
        BaseInput,
        BaseSelect,
        'loading-anim': LoadingAnimVue,
        BButton,
        'base-alert': BaseAlert,
        'base-dialog': BaseDialog
    },
    data () {
      return {
        years: [],
        months: [
          { value: '01', text: '01' },
          { value: '02', text: '02' },
          { value: '03', text: '03' },
          { value: '04', text: '04' },
          { value: '05', text: '05' },
          { value: '06', text: '06' },
          { value: '07', text: '07' },
          { value: '08', text: '08' },
          { value: '09', text: '09' },
          { value: '10', text: '10' },
          { value: '11', text: '11' },
          { value: '12', text: '12' }
        ],
        holdername: '',
        cardnumber: '',
        month: '',
        year: '',
        cvv: '',
        showDialog: false,
        dialogText: ''
      }
    },
    async mounted () {
        var _this = this
        var transactionId = this.$route.query.id
        var token = this.$route.query.token
        var now = new Date()
        if (token && !this.$route.query.redirect && !this.$route.query.ko) {
            now.setHours(now.getHours() + 24)
            _this.$cookies.set('api_token', token, now, '/', getBaseDomain(), true)
        }
        var previousTransactionId = sessionStorage.getItem('transactionId')
        var minutesLogout = sessionStorage.getItem('minutesLogout') != null && transactionId === previousTransactionId ? parseInt(sessionStorage.getItem('minutesLogout')) : 0
        if (transactionId && this.isGuid(transactionId)) {
            sessionStorage.setItem('transactionId', transactionId)
        }
        setInterval(function () {
            minutesLogout++
            if (minutesLogout > 60) {
                this.$router.push({path: 'payments-gateway', query: {expired: true}})
            }
            sessionStorage.setItem('minutesLogout', minutesLogout)
            if (minutesLogout % 15 === 0 && minutesLogout !== 60) {
                _this.dialogText = `${_this.$t('payments.weInform1')} ${(60 - minutesLogout).toString()} ${_this.$t('payments.weInform2')}`
                _this.showDialog = true
            }
            if (minutesLogout === 60) {
                this.$router.push({path: 'payments-gateway', query: {expired: true}})
            }
        }, 60000)
        if (this.$route.query.redirect && !this.$route.query.ko) {
            var bearer = `Bearer ${_this.$cookies.get('api_token')}`
            this.$api.get(`Payments/SecurePayments/${this.$route.query.id}`, {headers: {'Authorization': bearer}}).then((result) => {
                if (result.data.exceptionType) {
                    this.$store.dispatch('showDangerAlert', result.data.exceptionType)
                } else {
                    location.href = result.data.data
                }
            }).catch(function (error) {
                if (error.message) {
                    this.$store.dispatch('showDangerAlert', error.message)
                }
            })
        } else {
            if (inProductionEnv) {
                await import('../../../../static-appopensalud/paytpvProduccion.js')
            } else {
                await import('../../../../static-appopensalud/paytpvPruebas.js')
            }
        }
    },
    methods: {
        _years () {
            var years = []
            var currentYear = new Date().getFullYear()
            var currentYearSplitted = parseInt(currentYear.toString().substr(2, 3), 10)
            var currentYearPlus10 = currentYearSplitted + 10
            for (var i = currentYearSplitted; i < currentYearPlus10; i++) {
                years.push({value: i, text: i})
            }
            return years
        },
        pay () {
            var _this = this
            var x = new PAYTPV.Tokenizator()
            if (!this.holdername) {
                this.$store.dispatch('showDangerAlert', this.$t('payments.enterHolderName'))
            } else if (!this.cardnumber) {
                this.$store.dispatch('showDangerAlert', this.$t('payments.enterCardNumber'))
            } else if (!this.month) {
                this.$store.dispatch('showDangerAlert', this.$t('payments.selectMonth'))
            } else if (!this.year) {
                this.$store.dispatch('showDangerAlert', this.$t('payments.selectYear'))
            } else if (!this.cvv) {
                this.$store.dispatch('showDangerAlert', this.$t('payments.enterCvv'))
            } else {
                x.getToken(document.forms['paytpvPaymentForm'], function (data) {
                    if (data.errorID !== 0 || data.paytpvToken === '') {
                        _this.$store.dispatch('showDangerAlert', data.errorText.replace('Ãº', 'ú'))
                    } else {
                        var payData = {
                            id: _this.$route.query.id,
                            paytpvToken: data.paytpvToken
                        }
                        _this.$api.post('Payments/Paycomet', payData).then((result) => {
                            if (result.data.exceptionType) {
                                this.$store.dispatch('showDangerAlert', result.data.exceptionType)
                            } else {
                                location.href = result.data.data
                            }
                        }).catch(function (error) {
                            if (error.message) {
                                this.$store.dispatch('showDangerAlert', error.message)
                            }
                        })
                    }
                })
            }
        },
        retry () {
            var _this = this
            var retryUrl = `${_this.$helpers.getV2AppUrl('payments-gateway')}?id=${_this.$route.query.id}&token=${_this.$route.query.token}`
            window.location = retryUrl
        },
        hideDialog () {
            this.showDialog = false
        },
        isGuid (value) {
        return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)
        }
    },
    created () {
        this.years = this._years()
    }

  }
</script>

<style lang="less">
@import '~css/opensalud-theme';

.bold{
    font-weight: bold;
}

.flexCenter{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5vh;
}
</style>


// WEBPACK FOOTER //
// src/components/public/payments/PaymentsGateway.vue